import { handleActions } from "redux-actions";

import { globalError } from "./actions";

const initialState = { errorMessageGlobal: null };

export const errorReducer = handleActions(
    {
        [globalError]: (state, { payload }) => ({
            ...state,
            errorMessageGlobal: payload
        })
    },
    initialState
);
